module.exports = __webpack_public_path__ + "static/img/cobg.192af93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cobg.jpg
// module id = 391
// module chunks = 31